
define('template!catalogTemplatesCreateTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="catalog-templates-create-tpl">\n  <div class="header">\n    <div class="title">' +
((__t = ( _.i18n('catalogs.templates.edit') || _.i18n('catalogs.templates.createNew') || 'Template' )) == null ? '' : __t) +
'</div>\n  </div>\n\n  <div class="body">\n    <div class="item">\n      <div class="libelle">' +
((__t = ( _.i18n('common.content') || 'Content' )) == null ? '' : __t) +
'</div>\n      <div class="value content-region"></div>\n    </div>\n    <div class="item">\n      <div class="libelle">' +
((__t = ( _.i18n('common.type') || 'Type' )) == null ? '' : __t) +
'</div>\n      <div class="value type-region"></div>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

